// extracted by mini-css-extract-plugin
export default {"container":"mainLayout_container__XnJh2","fullscreen":"mainLayout_fullscreen__Uxjnl"};